import React from 'react';
import { 
    Flex, 
    Text,
    useMediaQuery, 
    useTheme,
    Grid,
    GridItem,
    Image
} from '@chakra-ui/react';

const Description = () => {
    //Elementos para responsive
    const { breakpoints } = useTheme();
    const [isGreaterThanMd] = useMediaQuery(`(min-width: ${breakpoints.lg})`);

    const assets = [
        { imgUrl: 'https://boomerang.s3.us-east-2.amazonaws.com/landings/thedistrict/description/img-amen-1.webp' },
    ];

    return (
        <Flex paddingTop={'5rem'} flexDirection={"column"} paddingBottom={isGreaterThanMd ? "1rem" : 0} w='100%' id='proyecto'>
            <Flex paddingBottom={isGreaterThanMd ? "2rem" : "1rem"} w={'100%'} justifyContent={"center"}>
                {isGreaterThanMd ?
                    <Text fontFamily={'AktivGrotesk-Bold'} fontSize={'28px'} lineHeight={'24.15px'} color='#10302B' >
                        Un <em>ícono</em> arquitectónico en Guadalajara
                    </Text>
                :
                    <Text fontFamily={'AktivGrotesk-Bold'} textAlign={"center"} fontSize={'20px'} lineHeight={'24.15px'} color='#10302B' >
                        Un <em>ícono</em> arquitectónico<br />en Guadalajara
                    </Text>
                }
            </Flex>
            <Grid templateColumns={isGreaterThanMd ? "repeat(5, 1fr)" : "repeat(2, 1fr)"}  px={isGreaterThanMd?24:8} maxW={'5xl'} margin='auto' pb={14} pt={{base: 5, md: 0}}>
                <GridItem display={isGreaterThanMd ? "none" : "grid"} colSpan={2} justifyContent='center' mb={10}>
                    <Flex paddingLeft={isGreaterThanMd?"2rem":0} justifyContent='center' h='100%'>
                        <Image 
                            src={assets[0].imgUrl}
                            width='100%' 
                            height='auto' 
                            alt='amenidades' 
                            style={{objectFit: 'contain', background: 'center'}}
                        />
                    </Flex>
                </GridItem>
                <GridItem colSpan={isGreaterThanMd?3:2} mb={isGreaterThanMd?0:8} alignSelf='center'>
                    <Flex flexDirection={"column"} py={isGreaterThanMd?20:0} px={isGreaterThanMd?10:2} textAlign={isGreaterThanMd?'start':'justified'}>
                        <Flex>
                            <Text fontFamily={'AktivGrotesk-Regular'} fontWeight={400} fontSize={isGreaterThanMd ? '16px':'14px'} lineHeight={isGreaterThanMd?'19.2px':'14.4px'} color='#545454'>
                            The District es un proyecto de usos mixtos de primera categoría que integra a la perfección todo lo que necesitas para vivir en confort: Área residencial, empresarial y comercial.
                            <br/>
                            <br/>
                            Además, contamos con espacios que te harán conectar con la naturaleza y tu esencia, gracias a los jardines lineales que crean un parque central para convivir en armonía con tu entorno.
                            </Text>
                        </Flex>
                    </Flex>
                </GridItem>
                <GridItem display={isGreaterThanMd ? "grid" : "none"} colSpan={2} justifyContent='center'>
                    <Flex paddingLeft={isGreaterThanMd?"2rem":0} justifyContent='center' h='100%'>
                        <Image 
                            src={assets[0].imgUrl}
                            width='100%' 
                            height='auto' 
                            alt='amenidades' 
                            style={{objectFit: 'contain', background: 'center'}}
                        />
                    </Flex>
                </GridItem>
            </Grid>
        </Flex>
    );
}
 
export default Description;
